// extracted by mini-css-extract-plugin
export default {"input":"Input_input__NdPPQ","rightIcon":"Input_rightIcon__EtL4w"};